/* eslint-disable no-console */
import { select } from 'typed-redux-saga'
import { AppSocketType, WorkerEvent } from 'Modules'
import { chatSelectors, getContourChat } from 'Pages/chat'

export function* createChatWsConnection() {
	try {
		const token = yield* select(chatSelectors.selectChatToken)
		const baseUrl = getContourChat(false)
		const url = `${baseUrl}?Authorization=${token}`
		navigator.serviceWorker?.controller?.postMessage({
			appSocketType: AppSocketType.UNI_CHAT,
			data: {
				type: WorkerEvent.CONNECT_SOCKET,
				payload: url,
			},
		})
	} catch (e) {
		console.log(e)
	}
}
